// extracted by mini-css-extract-plugin
module.exports = {"header-mobile":"HeaderMobile_header-mobile___uXzR","header-mobile-static":"HeaderMobile_header-mobile-static__9LsGS"};